import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function ResearchChatIndex() {
  const nav = useNavigate();
  const { data, isLoading } = useQuery({
    queryKey: ["research_chat_most_recent"],
    queryFn: async () => {
      const { data } = await supabase
        .from("research_chat_sessions")
        .select("id")
        .eq("is_archived", false)
        .order("last_message_at", { ascending: false, nullsFirst: false })
        .limit(1)
        .maybeSingle();
      return data;
    },
  });

  useEffect(() => {
    if (!isLoading && data?.id) nav(`/partner/research/chat/${data.id}`, { replace: true });
  }, [data, isLoading, nav]);

  async function startNew() {
    const { data: u } = await supabase.auth.getUser();
    if (!u.user) return;
    const { data: s } = await supabase
      .from("research_chat_sessions")
      .insert({ user_id: u.user.id })
      .select("id")
      .single();
    if (s) nav(`/partner/research/chat/${s.id}`);
  }

  return (
    <div className="h-full flex flex-col items-center justify-center text-center p-10 gap-3">
      <MessageSquare className="h-10 w-10 text-muted-foreground" />
      <h3 className="text-lg font-semibold">Research chat</h3>
      <p className="text-sm text-muted-foreground max-w-md">
        Ask anything about the research corpus. The agent searches transcripts, slides, FRED data, and the knowledge graph,
        with citations on every claim.
      </p>
      <Button onClick={startNew}>Start a new conversation</Button>
    </div>
  );
}
